import React from 'react'
import { XIcon } from '@heroicons/react/outline'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { authenticated } from '../../recoil/auth';
import { quizDeleted, quizLoading } from '../../recoil/quiz';
import { domainWeb } from '../../config/constants';
import axios from 'axios';

const QuizDeleteModal = (props) => {
  const auth = useRecoilValue(authenticated);
  const setLoading = useSetRecoilState(quizLoading);
  const [deleted, setDeleted] = useRecoilState(quizDeleted);

  const deleteQuiz = async () => {
    setLoading(true);
    props.closeDelete();
    try {
      let url = `${domainWeb}/quizzes/${props.id}`;
      await axios.delete(url,
        {headers: {
          'Content-Type': 'application/json', 
          'Accept': 'application/json', 
          'Authorization': 'Bearer ' + auth.token
        }},
      );
      setLoading(false);
      setDeleted(!deleted);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }; 

  return (
    <div className="fixed flex items-center justify-center w-screen min-h-screen bg-black bg-opacity-50">
        <div className="w-1/4 p-5 bg-white rounded-lg shadow">
            <div className="flex justify-between">
              <h3 className="text-lg font-semibold">Konfirmasi</h3>
              <XIcon className="w-5 h-5 cursor-pointer hover:text-blue-600" onClick={props.closeDelete} />
            </div>
            <p className="my-5">Yakin ingin menghapus kuis <span className="font-bold">{props.id}</span> ini?</p>
            <div className="flex items-center justify-center gap-3">
                <button type="button" onClick={deleteQuiz} className="px-5 py-3 text-sm text-white bg-blue-600 rounded-lg shadow hover:bg-blue-700 shadow-blue-100">Yakin</button>
                <button type="button" onClick={props.closeDelete} className="px-5 py-3 text-sm rounded-lg shadow bg-slate-50 hover:bg-slate-100 shadow-blue-100">Batal</button>
            </div>
        </div>
    </div>
  )
}

export default QuizDeleteModal